
<template>

    <span class="InputSelect FiledWrapper" :class="{'Ready':m_State=='Ready','Input':m_State=='Input'}">

        <div @mousedown="OnMouseDown" class="LabelPart Field">


            <t-label :value="m_Value"
                     :text="m_ValueText"
                     :OptionName="OptionName"
                     :Options="Options"
                     :nullable="nullable"
                     :title="title"
                     ref="InputSelectLabel"
                     class="Field"
                     :ComplexOptionName="ComplexOptionName"></t-label>

             
        </div>

        <div class="ClearIcon" v-show="m_Value != null" @click="OnClearButtonClick">✗</div>
        <div class="InputPart">
            <t-inputquery ref="InputSelectInput"
                          Strict="true"
                          :value="m_Text"
                          style="white-space:pre-wrap;"
                          :disabled="disabled"
                          :QueryApiUrl="QueryApiUrl"
                          PlaceHolder="請輸入關鍵字"
                          @blur="OnBlur"
                          @change="(text,row)=>{
                          if(row != null){
                              let optionValue = null;
                              let messageElement;

                              m_State = 'Ready';

                              $forceUpdate();


                              if(GetRowValueHandler != null){
                                   m_Value = GetRowValueHandler(row);

                                   this.$emit('input',m_Value);
                                   this.$emit('change',m_Value);
                              }


                              messageElement = $el.querySelector(':scope .error_message');


                              if(messageElement != null){
                                   messageElement.innerHTML = '';
                              } 

                              $refs.InputSelectInput.Clear();


                              this.LoadText();
                          }
                      }"
                          :CreateInputTextHandler="(text,row) => {
                                                                                                                        var text = '' ;
                                                                                                                        if(row != null)
                                                                                                                        {
                                                                                                                            text =  row.Text ;
                                                                                                                        }

                                                                                                                        return text;
                                                                                                                   }"
                          :CreateOptionTextHandler="CreateOptionTextHandler"
                          :CreateQueryRequestHandler="(text,row)=> {
return  {

                          Keyword:text ,
                          Text:text ,

                          Query : {
                              ValueSet :
                              {
                                  Keyword:text ,
                                  Text:text ,
                              } ,
                          }

                                                                                                                              };
                                      }" />
        </div>



    </span>




</template>
<script>
    import Utility from '@/Common/Utility'
    import TControlBase from '@/Common/TControlBase'
    import apiService from '@/Common/ApiService'



    export default {



        data() {
            return {
    
                m_State: 'Ready',
                m_Value: null,
                m_ValueText:null,
                m_Text: "",

                Options:[],
                m_Attribute: {
                    Options:[],
                },
            }
        }
        ,
        //props: ["value", "name", "DataType", "Attribute", "Options"],
        props: ["value", "name", "DataType", "Attribute",


            "nullable",
            "title",
            "OptionName",
            "ComplexOptionName",
            "CacheOption" ,

            "QueryTextApiUrl",
            "QueryApiUrl",
            "disabled", "nullable", "title",
            "CreateOptionTextHandler",
            "GetRowValueHandler" ,
        ],

        computed: {

        }
        ,
        methods: {

            UpdateElementByAttribute() {

            },

            LoadText() {
                if (this.m_Value != null && this.m_Value != "") {
                    if (this.QueryTextApiUrl != null) {

                        apiService.Post(
                            this.QueryTextApiUrl,
                            {
                                Value: this.m_Value
                            }
                        ).then(
                            function (responseData) {

                                this.Options = [
                                    {
                                        Value: this.m_Value,
                                        Text: responseData.Text
                                    }
                                ];

                                this.$forceUpdate();
                            }.bind(this)
                        ).catch(
                            function (err) {
                                alert(err)
                            }.bind(this)
                        );
                    }
                }
            } ,

            OnClearButtonClick() {
                this.m_Value = null;
                this.m_Text = "";
            } ,

            OnMouseDown(e) {
                let text;

                this.m_State = "Input";


                text = this.$refs.InputSelectLabel.$el.innerText;

                if (text != null) {
                    this.m_Text = text;
                }
                else {
                    this.m_Text = "";
                }

                setTimeout(
                    function () {
                        this.$refs.InputSelectInput.Focus();
 
                        this.$refs.InputSelectInput.Query();
                    }.bind(this),
                    200
                );
                this.$forceUpdate();
            },

            OnBlur(e) {
                this.m_State = "Ready";
                this.$forceUpdate();
            },

        },

        mounted() {
             
            TControlBase.call(this);

 
            this.$forceUpdate();

            if (this.value != null) {
                this.m_Value = this.value;
            }

            this.LoadText();

        },

        created() {
            let dateTimeObj;




        },
        watch: {
            value: function (newVal, oldVal) {

                this.m_Value = newVal,

                    this.$forceUpdate();

                this.LoadText();
            },

            DataType: function (newVal, oldVal) {

            },

            nullable: function (newVal, oldVal) {
            },

 


        }
    }
</script>
<style>
    .InputSelect .LabelPart .error_message {
        position: absolute;
    }
</style>
<style scoped>
    .InputSelect {
        width: auto;
        position:relative;
        display:inline-block;
        min-width:200px;
    }

        .InputSelect.Input .InputPart {
            margin-top: 3px;
            position:absolute;
            width:100%;
            background-color:#f5f5df;
            
        }

        .InputSelect .InputQuery {
            width: 100%!important;
            line-height: 25px;
            height: 36px;
            background-color: #f5f5df;
        }

        .InputSelect .InputPart {
            margin-top: 3px;
            position: absolute;
            min-width:300px;
            background-color: #f5f5df;
            display: block; 
        }

    
    .InputSelect .LabelPart {
        display: inline-block;
        border: 1px solid #a0a0a0;
        padding-left: 10px;
        padding-right: 10px;
        line-height: 25px;
        width: 100%;
        text-align: left;
    }




        .InputSelect .ClearIcon {
            position: absolute;
            right: 2px;
            top: 0px;
            display: inline-block;
            cursor: pointer;
            display:inline-block;
        }

            .InputSelect .LabelPart .Label {
                line-height: 25px;
                display:block;
                min-height:25px;
            }

    /deep/ .InputQuery input[type='Text'] {
        font-size: 15px;
        width: 100%;
        line-height: 33px;
        height: 35px;
        background-color:#f5f4eb;
    }


    .InputSelect.Ready .LabelPart {
        display: block;
    }

    .InputSelect.Ready .InputPart {
        display: none;
        width: 100%;
    }


    .InputSelect.Input .LabelPart {
        display: block;
    }

    .InputSelect.Input .InputPart {
        display: block;
        width:100%;
    }

    
</style>
